<template>
  <CheckoutStep>
    <div class="flex flex-col gap-32 md:flex-row">
      <div class="space-y-32 md:w-1/2">
        <h1 class="heading-1 mt-24 md:mt-0">
          {{ i18n(translations.title) }}
        </h1>
        <div class="space-y-16">
          <div class="body-1">{{ i18n(translations.notEligibleMessage) }}</div>

          <div class="flex flex-col justify-end gap-16 md:flex-row">
            <RevButton
              full-width="adaptive"
              variant="primary"
              @click="emit('exit-to-cart')"
            >
              {{ i18n(translations.goToCart) }}
            </RevButton>

            <RevButton
              full-width="adaptive"
              variant="secondary"
              @click="emit('exit-to-continue-shopping')"
            >
              {{ i18n(translations.continueShopping) }}
            </RevButton>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-center md:w-1/2">
        <RevIllustration
          :alt="i18n(translations.emptyBasketIcon)"
          class="py-44"
          :height="223"
          src="/img/bouygues/emptyBasket.svg"
          :width="236"
        />
      </div>
    </div>
  </CheckoutStep>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import type { BuybackOffer } from '@backmarket/http-api'
import CheckoutStep from '@backmarket/nuxt-layer-checkout/components/CheckoutStep/CheckoutStep.vue'
import { getSelectedMobilePlan } from '@backmarket/nuxt-layer-checkout/utils/mobilePlan/getSelectedMobilePlan'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './NotEligible.translations'

const logger = useLogger()
const i18n = useI18n()
const $httpFetch = useHttpFetch()

const props = defineProps<{
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems']
  swapOffer: BuybackOffer | null
}>()

const emit = defineEmits<{
  update: []
  'exit-to-cart': []
  'exit-to-continue-shopping': []
}>()

defineOptions({
  inheritAttrs: false,
})

onMounted(async () => {
  const bouyguesMobilePlanOffer = getSelectedMobilePlan(props.items)

  if (bouyguesMobilePlanOffer) {
    try {
      await $httpFetch('/bm/cart/services', {
        method: 'DELETE',
        body: { offerId: bouyguesMobilePlanOffer.id },
      })

      emit('update')
    } catch (err) {
      const error = err as Error
      logger.error(error.message, {
        error,
        owners: ['bot-squad-b2cservices-front'],
      })
    }
  }
})
</script>
